export const CREATED_MAPPINGS_SUCCESS = "Mappings created successfully!";
export const CREATED_MAPPINGS_ERROR = "Failed to create mappings";
export const ENABLED_MAPPINGS_SUCCESS = "Mappings enabled successfully!";
export const ENABLED_MAPPINGS_ERROR = "Failed to enable mappings";
export const DISABLED_MAPPINGS_SUCCESS = "Mappings disabled successfully!";
export const DISABLED_MAPPINGS_ERROR = "Failed to disable mappings";
export const DELETED_MAPPINGS_SUCCESS = "Mappings deleted successfully!";
export const DELETED_MAPPINGS_ERROR = "Failed to delete mappings";
export const SPACE_INFO_LOADING_ERROR = "Failed to get space info";
